import { useEffect, Component } from "react";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Summary from "@/sections/Summary";
import Architecture from "@/sections/Architecture";
import ForecastSplit from "@/sections/ForecastSplit";
import WhatUsersSee from "@/sections/WhatUsersSee";
import Findings from "@/sections/Findings";
import FeeScope from "@/sections/FeeScope";
import Timeline from "@/sections/Timeline";
import Risks from "@/sections/Risks";
import Decisions from "@/sections/Decisions";
import Closing from "@/sections/Closing";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-paper flex items-center justify-center p-8 font-mono text-sm text-fog">
          Something went wrong while rendering. {String(this.state.error)}
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-paper text-coal antialiased">
        <div id="top" />
        <Hero />
        <Nav />
        <main className="pb-4">
          <Summary />
          <Architecture />
          <ForecastSplit />
          <WhatUsersSee />
          <Findings />
          <FeeScope />
          <Timeline />
          <Risks />
          <Decisions />
        </main>
        <Closing />
      </div>
    </ErrorBoundary>
  );
}
